import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, IconButton, Grid, Typography, Avatar, makeStyles, Tooltip } from "@material-ui/core";
import { FaImage, FaTrash, } from "react-icons/fa";
import GridInputRow from "../form-grids/GridInputRow";
import { DragNDropUploader } from "./DragNDropUploader";
import { DefaultDragNDropService } from "./DragNDropService";

/**
 * @author 
 * AndréK 24-08-22
 */

export const ImageUploadCard = (props) => {
    const { t } = useTranslation();
    const useStyles = makeStyles((theme) => ({
        large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
            marginBottom: "15px",
        },
        maximumHeight: {
            height: "100%",
        },
        marginHeightBottom: {
            paddingBottom: "10px",
        },
    }));

    const classes = useStyles();

    //Props Padrões
    const {id, idClient, idStockLocation, zeroedBarcode, userId, uploadCallBack, description, isRegister, iconBase64, onClick, endPoint, cantRemove } = props

    //Função de remoção de imagem on Click

    ////(OBS : a variavel endPoint é o mesmo nome do obj Controller )////
    //Exemplo : Controller -> CustomFileUploaderStoreController , EndPoint -> CustomFileUploaderStore

    const handleRemoveProductItemImage = (Id) => {
        DefaultDragNDropService[endPoint]({ Id: Id, loggedUserId: userId })
            .then((response) => {
                uploadCallBack();
            })
            .catch((e) => {});
    }

    return (

        <Card style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", paddingBottom: "50px", }}>
            {isRegister ?
                <>
                    <CardContent>
                        {!cantRemove ? (
                            <GridInputRow>
                                <Tooltip
                                    title={
                                        <Typography>
                                            {t("removeIcon")}
                                        </Typography>
                                    }
                                >
                                    <Grid item xs={1}>
                                        <FaTrash onClick={() => { handleRemoveProductItemImage(id) }} />
                                    </Grid>
                                </Tooltip>
                            </GridInputRow>
                        ) : null}
                        <GridInputRow>
                            <Grid item xs={12} md={12}>
                                {iconBase64 ?
                                    <Avatar
                                        variant="rounded"
                                        className={classes.large}
                                        src={`data:image/png;base64,${iconBase64}`}
                                    />
                                    :
                                    <Tooltip
                                        title={
                                            <Typography>
                                                {t("dragFileToUpload")}
                                            </Typography>
                                        }
                                    >
                                        <DragNDropUploader
                                            open={props.open}
                                            uploadCallBack={uploadCallBack}
                                            aditionalData={[{'LoggedUserId': userId},
                                                {'Id': id},
                                                {'IdClient': idClient},
                                                {'IdStockLocation': idStockLocation},
                                                {'ZeroedBarcode': zeroedBarcode}
                                            ]}
                                            endpoint={`/${endPoint}`}
                                            id={id}
                                        />
                                    </Tooltip>
                                }
                            </Grid>
                        </GridInputRow>
                        <GridInputRow style={{ minHeight: "50px" }}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"button"}>{description}</Typography>
                            </Grid>
                        </GridInputRow>
                    </CardContent>
                </>
                :
                <CardContent>
                    <GridInputRow>
                        <Grid item xs={12} md={12}>
                            <IconButton onClick={onClick}>
                                {iconBase64 ?
                                    <Avatar
                                        variant="rounded"
                                        className={classes.large}
                                        src={`data:image/png;base64,${iconBase64}`} />
                                    : <FaImage className={classes.large}></FaImage>}
                            </IconButton>
                        </Grid>
                    </GridInputRow>
                    <GridInputRow>
                        <Grid item xs={12} md={12}>
                            <Typography variant={"button"}>{description}</Typography>
                        </Grid>
                    </GridInputRow>
                </CardContent>}
        </Card>

    );
};


//Exemplo :

//Upload de Imagem / Arquivo com Retorno visual
{/* 
    <ImageUploadCard
        id={id}
        userId={userId}
        uploadCallBack={() => { handleReloadImg() }}
        isRegister={true}
        iconBase64={base64Image}
        endPoint={"CustomFileUploaderUser"}
    />
 */}

//Upload de arquivo sem retorno visual 
{/* 
    <ImageUploadCard
        uploadCallBack={uploadCallBack}
        cantRemove
        id={id}
        userId={userId}
        isRegister={true}
        endPoint={"CustomFileUploaderInventoryPreparation"}
    /> 
*/}